export default "__VITE_ASSET__DUDnGi1V__"